import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SECURE_API_URLS } from '../config/api.urls';
import { Subscription } from '../_models/subscription';
import { IPagination } from '../_models/pagination';

@Injectable({
    providedIn: 'root'
})
export class AdminSubscriptionService {
    constructor(private httpClient: HttpClient) {}

    loadSubscriptions(page: number): Observable<IPagination> {
        return this.httpClient.get<{ data: IPagination }>(SECURE_API_URLS.SUBSCRIPTIONS_BASE_URL + '?page=' + page)
            .pipe(map(response => response.data));
    }

    loadSubscription(id: string): Observable<Subscription> {
        return this.httpClient.get<{ data: Subscription }>(SECURE_API_URLS.SUBSCRIPTIONS_BASE_URL + '/' + id)
            .pipe(map(response => response.data));
    }
}
